/**
 * Parses a date value that may be a UTC datetime string without the 'Z' suffix (as returned
 * by the API) — strings missing it are parsed as local time, silently shifting by the client's offset.
 * @registry Parses a UTC-naive date string (or Date) into a correctly-offset `Date`.
 */
export function parseUtcDate(date: Date | string): Date {
  if (date instanceof Date) return date;
  const s = String(date);
  return new Date(s.endsWith('Z') ? s : `${s}Z`);
}
